export default __webpack_public_path__ + "static/media/modal_2_pet.0681c853.svg";